/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import ImpyImg from "../../image/emptyOrder.png";

const AccessorieList = ({ ImgBasUrl, item, index, currency, handleAddToCart, handleDecrement, handleIncrement }) => {

    const { t } = useTranslation();
    const [showindex, setShowIndex] = useState(3);
    const isSelected = item.totalcart >= 1;

    const handleShowMore = (length) => {
        if (showindex === length) {
            setShowIndex(3);
            return;
        }
        setShowIndex(item.feature_tags.split(',').length);
    };

    return (<div key={index} className="packages_box">
        <div className="py-[10px] px-[15px]">
            <div className="flex max-_430_:flex-wrap items-start gap-[10px]">
                <ImgLoad url={ImgBasUrl + item.img} Customestyle={"w-[140px] max-_430_:w-full h-[140px] object-cover rounded-[15px] border-[1px]"} />
                <div className="overflow-hidden">
                    <h1 className="font-[500] text-[20px] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.title}</h1>
                    <h1 className="text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.tags}</h1>
                    {item.feature_tags.split(',').map((item, index) => {
                        if (index < showindex) {
                            return <p key={index} className="text-gray-600 text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis">• {item.trim()}</p>
                        }
                    })}
                    <button onClick={() => handleShowMore(item.feature_tags.split(',').length)} className='text-[#682afb] text-[14px]'>{item.feature_tags.split(',').length - showindex === 0 ? t("Show Less") : t("Show More")}</button>
                </div>
            </div>
            <div className="mt-[5px] flex max-_430_:flex-col max-_430_:items-start items-center justify-between">
                <div className="flex items-center gap-[5px] text-[17px] max-_430_:text-[14px]">
                    <span className="line-through text-gray-500">{currency}{item.price}</span>
                    <h1 className="font-bold">{currency}{item.discount_price}</h1>
                    <p className="text-green-600">{item.discount_percentage}% {t("OFF")}</p>
                </div>
                <div className="text-center max-_430_:mt-[10px] max-_430_:w-full max-_430_:flex max-_430_:items-center max-_430_:gap-[10px]">
                    <div onClick={() => !isSelected && handleAddToCart(item.id, isSelected)} className='add_button max-_430_:w-full'>
                        {isSelected
                            ? <div className="flex items-center">
                                <button onClick={() => handleDecrement(item.id)} className='bg-[#682afb] text-white px-[7px] text-[18px] max-_430_:w-full'>-</button>
                                <span className='bg-[#692afb44] text-[#682afb] px-[8px] text-[18px] max-_430_:w-full'>{item.totalcart}</span>
                                <button onClick={() => handleIncrement(item.id)} className='bg-[#682afb] text-white px-[5px] text-[18px] max-_430_:w-full'>+</button>
                            </div>
                            : <button className={`py-[2px] px-[20px] ${isSelected && "bg-[#682afb] text-white"} text-[#682afb]`}>{t("ADD")}</button>}
                    </div>
                </div>
            </div>
        </div>
    </div>)
}

const Accessorie = () => {

    const { t } = useTranslation();
    const { ApiBasUrl, ImgBasUrl, setTotalCart, totalcart, cartstatus, SECRET_KEY } = useContext(MyContext);

    const [accessories, setAccessories] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errortext, setErrorText] = useState("");

    const UpdateRef = useRef(false);

    const navigate = useNavigate();
    const currency = secureLocalStorage.getItem('currency');

    const updateCartStorage = (newCartItems) => {

        const existing = localStorage.getItem('Cartitem');
        let otherCartItems = [];

        if (existing) {
            const bytes = CryptoJS.AES.decrypt(existing, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            otherCartItems = decryptedData.cartitem || [];
        }

        const combined = {
            packagecartitem: [...newCartItems],
            cartitem: [...otherCartItems],
        };

        const total = newCartItems.length + otherCartItems.length;

        if (total > 0) {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combined), SECRET_KEY).toString();
            localStorage.setItem('Cartitem', encrypted);
        } else {
            localStorage.removeItem('Cartitem');
        }

        setTotalCart(total);
    };

    useEffect(() => {

        if (!cartstatus) return;

        const savedCart = localStorage.getItem('Cartitem');
        let packageItems = [];

        if (savedCart) {
            const bytes = CryptoJS.AES.decrypt(savedCart, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            packageItems = decryptedData.packagecartitem || [];
        }

        const enrichedList = accessories.map((accessory) => {
            const matchedItem = packageItems.find(
                (item) => item.item_type === 'accessory' && item.service_id === accessory.id
            );

            if (matchedItem) {
                return { ...accessory, totalcart: matchedItem?.totalcart };
            } else {
                return { ...accessory, totalcart: 0 };
            }
        });

        setAccessories(enrichedList);
    }, [cartstatus]);

    useEffect(() => {

        const savedCart = localStorage.getItem('Cartitem');

        let cartData = [];
        let packageItems = [];

        if (savedCart) {
            const bytes = CryptoJS.AES.decrypt(savedCart, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            packageItems = decryptedData.packagecartitem || [];
            cartData = decryptedData.cartitem || [];
            setCartItems(packageItems);
            setTotalCart(packageItems.length + cartData.length);
        }

        const fetchAccessories = async () => {

            if (UpdateRef.current) return;
            UpdateRef.current = true;

            try {
                const store = secureLocalStorage.getItem('Store');
                const selectedCar = secureLocalStorage.getItem('Selectcar');

                const { store_id } = JSON.parse(store);
                const { model_id } = JSON.parse(selectedCar);

                const res = await axios.post(`${ApiBasUrl}/accessorie_list.php`, {
                    model_id,
                    store_id,
                });

                const accessoryList = res.data.AccessoryList || [];
                setErrorText(res.data.ResponseMsg);

                const enrichedList = accessoryList.map((accessory) => {
                    const matchedItem = packageItems.find(
                        (item) => item.item_type === 'accessory' && item.service_id === accessory.id
                    );

                    if (matchedItem) {
                        return { ...accessory, totalcart: matchedItem?.totalcart };
                    } else {
                        return accessory;
                    }

                });

                setAccessories(enrichedList);
                setLoading(false);

            } catch (error) {
                console.error('Error fetching accessories:', error);
                setLoading(false);
            }
        };

        fetchAccessories();
    }, []);

    useEffect(() => {
        updateCartStorage(cartItems);
    }, [cartItems]);

    const handleAddToCart = (id, alreadyInCart) => {

        const updatedAccessories = accessories.map((item) =>
            item.id === id
                ? { ...item, totalcart: 1 }
                : item
        );

        setAccessories(updatedAccessories);

        if (!alreadyInCart) {
            const selected = accessories.find((item) => item.id === id);
            const newItem = {
                service_id: selected.id,
                discount_percentage: selected.discount_percentage,
                discount_price: selected.discount_price,
                itemdisprice: selected.discount_price,
                itemprice: selected.price,
                price: selected.price,
                service_img: selected.img,
                service_title: selected.title,
                totalcart: 1,
                item_type: 'accessory',
                totalprice: selected.discount_price
            };

            setCartItems((prev) => [...prev, newItem]);
        }
    };

    const handleIncrement = (id) => {
        const FilterData = accessories.map(item => {
            if (item.id === id) {
                const count = item.totalcart + 1;
                return { ...item, totalcart: count }
            } else {
                return item;
            }
        })

        setAccessories(FilterData);

        const FilterCartData = cartItems.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart + 1;
                const TotalDicPrice = (Number(item.itemdisprice) * count);
                const TotalPrice = (Number(item.itemprice) * count);
                return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice }
            } else {
                return item;
            }
        })

        setCartItems(FilterCartData);
    };


    const handleDecrement = (id) => {

        const FilterData = accessories.map(item => {
            if (item.id === id) {
                const count = item.totalcart - 1;
                return { ...item, totalcart: count }
            } else {
                return item;
            }
        })

        setAccessories(FilterData);

        const updatedCart = cartItems.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart - 1;
                if (count === 0) {
                    return null;
                } else {
                    const TotalDicPrice = (Number(item.itemdisprice) * count);
                    const TotalPrice = (Number(item.itemprice) * count);
                    return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice }
                }
            }
            return item;
        }).filter(item => item !== null);

        setCartItems(updatedCart);
    };

    return (
        <div className='details_page'>
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">
                    <div className="section_details">
                        <div className="flex flex-wrap items-start gap-[20px]">
                            {accessories.length >= 1
                                ? accessories.map((item, index) => (
                                    <AccessorieList key={index} ImgBasUrl={ImgBasUrl} item={item} index={index} currency={currency} handleAddToCart={handleAddToCart} handleDecrement={handleDecrement} handleIncrement={handleIncrement} />
                                ))
                                : <div className="w-full h-[500px] flex items-center justify-center">
                                    <div className="text-center">
                                        <img src={ImpyImg} className='w-[300px]' alt="ImpyImg" />
                                        <h1 className='text-[17px] text-gray-500 font-bold'>{errortext}</h1>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>}

            {totalcart !== 0 && <div className="fixed bottom-[10px] left-0 right-0">
                <div className="flex items-center justify-center cursor-pointer">
                    <div className="bg-[#682afb] py-[8px] px-[15px] inline-block rounded-[50px]">
                        <button onClick={() => navigate("/cart", { state: { title: "Accessorie", path: "/accessorie" } })} className="flex items-center">
                            <div className="text-white flex items-center gap-[10px]">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 21C10 21.552 9.55501 22 9.005 22C8.45701 22 8 21.552 8 21C8 20.448 8.43499 20 8.98499 20H9.005C9.55501 20 10 20.448 10 21ZM17.005 20H16.985C16.435 20 16 20.448 16 21C16 21.552 16.457 22 17.005 22C17.555 22 18 21.552 18 21C18 20.448 17.555 20 17.005 20ZM21.459 8.44701L20.444 14.617C20.185 16.046 19.574 17.499 17 17.499H8.73401C7.49801 17.499 6.43403 16.576 6.25903 15.353L4.74902 4.78799C4.64502 4.05399 4.00601 3.5 3.26501 3.5H3C2.724 3.5 2.5 3.276 2.5 3C2.5 2.724 2.724 2.5 3 2.5H3.26599C4.50199 2.5 5.56597 3.423 5.74097 4.646L5.86304 5.5H19C19.744 5.5 20.443 5.82699 20.92 6.39799C21.396 6.969 21.592 7.71601 21.459 8.44701ZM19.615 13.5H13C12.724 13.5 12.5 13.276 12.5 13C12.5 12.724 12.724 12.5 13 12.5H19.7791L20.473 8.276C20.554 7.829 20.436 7.381 20.151 7.039C19.865 6.696 19.445 6.5 18.999 6.5H6.005L7.25 15.212C7.354 15.946 7.99301 16.5 8.73401 16.5H17C18.754 16.5 19.218 15.778 19.459 14.447L19.615 13.5Z" fill="white" />
                                </svg>
                                <div className="text-center leading-[18px]">
                                    <h1>{totalcart} {t("Service Added")}</h1>
                                    <h1 className='font-[500]'>{t("VIEW CART")}</h1>
                                </div>
                            </div>
                            <svg className='ms-[10px]' width="16" height="20" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>}

        </div>
    )
}

export default Accessorie;
/* jshint ignore:end */

export const ImgLoad = ({ url, Customestyle }) => {

    const [imgLoaded, setImgLoaded] = useState(false);

    return (<>
        <img
            src={url}
            alt="Model"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${Customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    </>
    )
}